import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpCommonActions } from "../../actions/mp-common.actions";
import { VendorsState } from "../../models/mp-common/vendors-state";

const initialState: VendorsState = {
	loading: true,
	allRetrieved: false
};

const reducer = createReducer(
	initialState,
	on(MpCommonActions.vendors.getApi, (state) => _.merge(_.cloneDeep(state), { loading: true })),
	on(MpCommonActions.vendors.getSuccess, (state, action) => {
		const existing = _.cloneDeep(_.get(state, "vendors", []));
		const vendors = _.unionBy(existing, action.vendors, "id");
		return { vendors, loading: action.loading, allRetrieved: action.allRetrieved };
	}),
	on(MpCommonActions.vendors.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

export function vendorsReducer(state: VendorsState | undefined, action: Action): VendorsState {
	return reducer(state, action);
}
